// extracted by mini-css-extract-plugin
export default {"section":"TransitTab_section__cEz7+","title":"TransitTab_title__Fqyr0"};